export default __webpack_public_path__ + "chevronleft.721450ba.svg";